import styled from 'styled-components';
import {fontStyles, theme} from '@styles/theme';

export const TableHeaderCell = styled.th`
  position: relative;
  padding: 16px 8px;
  text-align: left;
  border: 1px solid ${theme.colors.basic06};
  background-color: ${theme.colors.basic07};
  overflow: hidden;
  text-overflow: ellipsis;
  &:first-child {
    padding: 16px 24px;
    width: 20px;
  }
  &:last-child {
    padding: 16px 24px;
    width: 30px;
  }
`;

export const TableCell = styled.td`
  padding: 8px;
  border: 1px solid ${theme.colors.basic06};
  position: relative;
  text-overflow: ellipsis;
  &:first-child {
    padding: 16px 24px;
  }
  &:last-child {
    padding: 16px 24px;
  }
`;


export const HeaderTextWithIcon = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

// Стили для инпута поиска
export const SearchInputContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  background-color: ${theme.colors.basic08};
`;

export const StyledSearchInput = styled.input`
  ${fontStyles.tinyNum}
  padding: 16px 8px;
  width: 100%;
  outline: none;
  border: 0;
`;

export const ClearButton = styled.button`
  position: absolute;
  right: 4px;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  &:hover {
    background-color: ${theme.colors.basic06};
    border-radius: 50%;
  }
`;

export const TableStatusWrapper = styled.div`
  display: flex;
`;

export const UserNameBlockWrapper = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;

export const UserNameWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
